const translation = {
  title: '探索',
  sidebar: {
    discovery: '发现',
    chat: '智聊',
    workspace: '工作区',
    action: {
      pin: '置顶',
      unpin: '取消置顶',
      rename: '重命名',
      delete: '删除',
    },
    delete: {
      title: '删除程序',
      content: '您确定要删除此程序吗？',
    },
  },
  apps: {
    title: '探索 Dify 的应用',
    description: '使用这些模板应用程序，或根据模板自定义您自己的应用程序。',
    allCategories: '推荐',
  },
  appCard: {
    addToWorkspace: '添加到工作区',
    customize: '自定义',
  },
  appCustomize: {
    title: '从 {{name}} 创建应用程序',
    subTitle: '应用程序图标和名称',
    nameRequired: '应用程序名称不能为空',
  },
  category: {
    Assistant: '助手',
    Writing: '写作',
    Translate: '翻译',
    Programming: '编程',
    HR: '人力资源',
  },
}

export default translation
